import React, { useEffect, useState } from 'react'
import icons from "../../../../../Data/icons";
const RuleComponent = ({classes , rule ,rulesArr}) => {
    const [ruleInputValue ,setRuleInputValue] = useState("")
    
    useEffect(()=>{
        setRuleInputValue(rule.value)
    },[rule])
    
    const RulesIcon = icons.levels
    const handleRuleChange=(e)=>{
        const {value}= e.target
        setRuleInputValue(value
        )
        const updatedRule = rulesArr.find((data=>data.id === rule.id))
        updatedRule.value= value
      }
     
      
  return (
    <div className={classes.formCol} key={rule.id}>
    <label htmlFor="">{rule.slug}</label>
    <div className={classes.iconInput}>
       <RulesIcon /> 
    </div>
    <input
      type="text"
      placeholder="ادخل اسم القاعدة"
      value={ruleInputValue}
      onChange={handleRuleChange}
      className={classes.inputCustom}
    />
  </div>
  )
}

export default RuleComponent